(function () {
  'use strict';

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getInitials(name) {
    if (!name) return '';
    var parts = name.trim().split(/\s+/);
    var first = parts[0] ? parts[0].charAt(0) : '';
    var last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
  }

  // Pull `n` reviews out of the cached Judge.me widget HTML stashed in the
  // section's <script type="text/template">.
  function parseReviews(html, max) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var nodes = tmp.querySelectorAll('.jdgm-rev');
    var out = [];
    for (var i = 0; i < nodes.length && out.length < max; i++) {
      var node = nodes[i];
      var author = (node.querySelector('.jdgm-rev__author') || {}).textContent || '';
      var body = (node.querySelector('.jdgm-rev__body') || {}).textContent || '';
      var iconEl = node.querySelector('.jdgm-rev__icon');
      var avatar = iconEl ? (iconEl.textContent || '').trim() : '';
      var avatarImg = iconEl && iconEl.querySelector('img') ? iconEl.querySelector('img').getAttribute('src') : '';

      // Stars: count `.jdgm-star.jdgm--on` (full only — Judge.me reviews don't
      // commonly use halves at the per-review level).
      var starsRoot = node.querySelector('.jdgm-rev__rating') || node;
      var fullStars = starsRoot.querySelectorAll('.jdgm-star.jdgm--on').length;
      // Fallback: `data-score` on `.jdgm-rev__rating`
      if (!fullStars) {
        var ds = starsRoot.getAttribute('data-score');
        if (ds) fullStars = Math.round(parseFloat(ds));
      }
      fullStars = Math.max(0, Math.min(5, fullStars || 0));

      author = author.trim();
      body = body.trim();
      if (!author && !body) continue;

      out.push({
        author: author,
        body: body,
        stars: fullStars,
        avatarText: avatar,
        avatarImg: avatarImg,
      });
    }
    return out;
  }

  function renderStars(n) {
    var html = '';
    for (var i = 0; i < 5; i++) {
      var cls = 'section-pdp-areviews__star' + (i >= n ? ' section-pdp-areviews__star--empty' : '');
      html += '<span class="' + cls + '" aria-hidden="true">★</span>';
    }
    return '<div class="section-pdp-areviews__stars" role="img" aria-label="Rated ' + n + ' out of 5">' + html + '</div>';
  }

  function renderCard(review) {
    var initials = review.avatarImg
      ? '<img src="' + escapeHtml(review.avatarImg) + '" alt="" loading="lazy">'
      : escapeHtml(getInitials(review.author) || review.avatarText || '?');

    return (
      '<article class="section-pdp-areviews__card" data-pdp-areviews-card>' +
        '<div class="section-pdp-areviews__author-row">' +
          '<div class="section-pdp-areviews__avatar" aria-hidden="true">' + initials + '</div>' +
          '<p class="section-pdp-areviews__author">' + escapeHtml(review.author || 'Verified buyer') + '</p>' +
        '</div>' +
        '<div class="section-pdp-areviews__content">' +
          renderStars(review.stars) +
          '<p class="section-pdp-areviews__quote">' + escapeHtml(review.body) + '</p>' +
        '</div>' +
      '</article>'
    );
  }

  function initSection(section) {
    if (section.dataset.pdpAreviewsInit === '1') return;
    section.dataset.pdpAreviewsInit = '1';

    var track = section.querySelector('[data-pdp-areviews-track]');
    var viewport = section.querySelector('[data-pdp-areviews-viewport]');
    var prev = section.querySelector('[data-pdp-areviews-prev]');
    var next = section.querySelector('[data-pdp-areviews-next]');
    var source = section.querySelector('[data-pdp-areviews-source]');
    if (!track || !viewport || !source) return;

    var html = source.textContent || '';
    var reviews = parseReviews(html, 10);
    if (reviews.length === 0) {
      console.warn('[pdp-authored-reviews] no .jdgm-rev nodes found in widget metafield (length: ' + html.length + ')');
      section.style.display = 'none';
      return;
    }

    track.innerHTML = reviews.map(renderCard).join('');
    var cards = Array.from(track.children);
    var idx = 0;

    function applyPosition(animate) {
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(' + (-100 * idx) + '%)';
      if (!animate) {
        // eslint-disable-next-line no-unused-expressions
        track.offsetHeight;
        track.style.transition = '';
      }
    }

    function setIdx(newIdx) {
      idx = Math.max(0, Math.min(cards.length - 1, newIdx));
      applyPosition(true);
      syncNav();
    }

    function syncNav() {
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === cards.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { setIdx(idx - 1); });
    if (next) next.addEventListener('click', function () { setIdx(idx + 1); });

    // Touch swipe — basic horizontal threshold.
    var touchStartX = null;
    viewport.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) touchStartX = e.touches[0].clientX;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (touchStartX == null) return;
      var endX = (e.changedTouches[0] || {}).clientX;
      if (endX == null) { touchStartX = null; return; }
      var dx = endX - touchStartX;
      if (Math.abs(dx) > 40) setIdx(idx + (dx < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    // Resize: translateX is %-based so position stays correct, but force a
    // no-anim apply for safety after layout shifts.
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () { applyPosition(false); });
    });

    applyPosition(false);
    syncNav();
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-areviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('[data-pdp-areviews]') : null;
    if (s) initSection(s);
  });
})();
